export interface ProductoModel {
  id: number;
  nombre: string;
  tipo: string;
  unidad: string;
  costo_sugerido: number;
  util_proveedor?: number | null;
}

export const TIPOS_PRODUCTO = [
  { value: 'CAJA', label: 'CAJA' },
  { value: 'BILLETE', label: 'BILLETE' },
  { value: 'RECARGA', label: 'RECARGA' },
  { value: 'PUESTO', label: 'PUESTO' },
  { value: 'INSUMO', label: 'INSUMO' },
];

export const TIPOS_FILTRO_PRODUCTO = [
  { value: 'CAJA', label: 'CAJA' },
  { value: 'BILLETE', label: 'BILLETE' },
  { value: 'RECARGA', label: 'RECARGA' },
  { value: 'PUESTO', label: 'PUESTO' },
  { value: 'INSUMO', label: 'INSUMO' },
];

export const TIPOS_EDITABLES = ['CAJA', 'BILLETE', 'RECARGA'];

export const UNIDADES_PRODUCTO = [
  { value: 'pieza', label: 'Pieza' },
  { value: 'kg', label: 'Kilogramo (kg)' },
  { value: 'litro', label: 'Litro' },
  { value: 'paquete', label: 'Paquete' },
];
